/*
* @描述: 开票弹窗
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/14 19:19
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div v-loading="loading" class="detail_wrap_container">
                <van-form ref="invoiceForm"
                          error-message-align="right"
                          input-align="right"
                          label-width="10em"
                          scroll-to-error>
                    <div class="m_page_little_title">
                        <span class="title">订单信息</span>
                    </div>
                    <van-field v-model="invoiceForm.order_num"
                               :is-link="source!=='detail'"
                               :rules="invoiceFormRules.order_num"
                               label="关联订单"
                               name="order_num"
                               placeholder="请选择关联订单"
                               readonly
                               required
                               @click="selectOrderDialog=true">
                    </van-field>
                    <van-field v-model="orderDetailsData.contact_name"
                               disabled
                               label="客户联系人"
                               name="contact_name"
                               placeholder="自动带出">
                    </van-field>
                    <van-field v-model="orderDetailsData.can_receivable_amount"
                               disabled
                               label="待回款金额"
                               name="can_receivable_amount"
                               placeholder="自动带出">
                    </van-field>
                    <van-field v-model="orderDetailsData.can_invoice_amount"
                               disabled
                               label="可开票金额"
                               name="can_invoice_amount"
                               placeholder="自动带出">
                    </van-field>
                    <div class="m_page_little_title">
                        <span class="title">开票申请信息</span>
                    </div>
                    <van-field :is-link="relateCustomList.length>0"
                               :value="invoiceForm.invoice_company_name"
                               label="开票公司"
                               name="invoice_company_name"
                               placeholder="请选择回款公司"
                               readonly
                               required
                               @click="showRelateCustomPicker=true">
                    </van-field>
                    <van-field
                            :rules="invoiceFormRules.invoice_type"
                            :value="invoiceForm.invoice_type?invoiceTypeColumns.find(item=>item.value===invoiceForm.invoice_type).text:''"
                            is-link
                            label="发票类型"
                            name="invoice_type"
                            placeholder="请选择发票类型"
                            readonly
                            required
                            @click="showRadioInvoiceTypePicker=true">
                    </van-field>
                    <van-field
                            v-if="invoiceForm.invoice_type===1||invoiceForm.invoice_type===2"
                            :rules="invoiceFormRules.invoice_method"
                            :value="invoiceForm.invoice_method?invoiceMethodColumns.find(item=>item.value===invoiceForm.invoice_method).text:''"
                            is-link
                            label="电子发票提供方式"
                            name="invoice_method"
                            placeholder="请选择电子发票提供方式"
                            readonly
                            required
                            @click="showRadioInvoiceMethodPicker=true">
                    </van-field>
                    <van-field
                            v-if="invoiceForm.invoice_type===1||invoiceForm.invoice_type===2"
                            v-model="invoiceForm.invoice_email"
                            :required="invoiceForm.invoice_method===1"
                            :rules="invoiceFormRules.invoice_email"
                            label="电子收票邮箱"
                            name="invoice_email"
                            placeholder="请输入电子收票邮箱">
                    </van-field>
                    <van-field v-model="invoiceForm.invoice_amount"
                               :rules="invoiceFormRules.invoice_amount"
                               label="本次开票金额"
                               name="invoice_amount"
                               placeholder="请输入本次开票金额"
                               required
                               @blur="handleInvoiceAmountInputBlur">
                    </van-field>
                    <van-field
                            :rules="invoiceFormRules.invoice_title_type"
                            :value="invoiceForm.invoice_title_type?invoiceTitleColumns.find(item=>item.value===invoiceForm.invoice_title_type).text:''"
                            is-link
                            label="开票对象"
                            name="invoice_title_type"
                            placeholder="请选择开票对象"
                            readonly
                            required
                            @click="showRadioInvoiceTitlePicker=true">
                    </van-field>
                    <div class="vertical_input_wrap">
                        <van-field v-model="invoiceForm.invoice_info"
                                   autosize
                                   label="开票信息"
                                   name="invoice_info"
                                   placeholder="自动带出关联客户的开票信息，可修改"
                                   type="textarea">
                        </van-field>
                    </div>
                    <van-field v-if="invoiceForm.invoice_type===3||invoiceForm.invoice_type===4"
                               v-model="invoiceForm.receive_name"
                               :rules="invoiceFormRules.receive_name"
                               label="收货人"
                               name="receive_name"
                               placeholder="请输入收货人"
                               required>
                    </van-field>
                    <van-field v-if="invoiceForm.invoice_type===3||invoiceForm.invoice_type===4"
                               v-model="invoiceForm.receive_phone"
                               :rules="invoiceFormRules.receive_phone"
                               label="收货人电话"
                               name="receive_phone"
                               placeholder="请输入收货人电话"
                               required>
                    </van-field>
                    <van-field v-if="invoiceForm.invoice_type===3||invoiceForm.invoice_type===4"
                               v-model="invoiceForm.receive_addr"
                               :rules="invoiceFormRules.receive_addr"
                               label="收货地址"
                               name="receive_addr"
                               placeholder="请输入收货地址"
                               required>
                    </van-field>
                    <div class="vertical_input_wrap">
                        <van-field v-model="invoiceForm.remark"
                                   autosize
                                   label="备注"
                                   name="remark"
                                   placeholder="请输入备注信息"
                                   type="textarea">
                        </van-field>
                    </div>
                    <div class="vertical_input_wrap">
                        <van-field label="附件"
                                   name="apply_attachments"
                                   readonly>
                            <template #input>
                                <div class="m_file_outer_wrap">
                                    <p v-if="invoiceForm.apply_attachments.length === 0" class="file_type_hint">
                                        支持Word、Excel、PDF等常见类型</p>
                                    <ul v-else class="m_upload_file_list">
                                        <li v-for="(file,file_idx) in invoiceForm.apply_attachments"
                                            class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"
                                                            effect="dark"
                                                            placement="top">
                                                            <span class="handle_icon_wrap"
                                                                  @click="handleClickPreview(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="删除"
                                                            effect="dark"
                                                            placement="top">
                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                  @click="invoiceForm.apply_attachments.splice(file_idx,1)">
                                <i class="iconfont icon-shanchu1"></i>
                            </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="m_upload_file_btn">
                                        <input class="upload_input"
                                               multiple
                                               type="file"
                                               @change="handleUploadFileChange($event)">
                                        <el-link :underline="false" type="primary">
                                            <i class="iconfont icon-shangchuan"></i>上传附件
                                        </el-link>
                                    </div>
                                </div>
                            </template>
                        </van-field>
                    </div>
                </van-form>
            </div>
            <div class="add_footer_wrap">
                <van-button size="large"
                            type="primary"
                            @click="handleClickConfirm">提交
                </van-button>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
            <van-popup v-model="showRelateCustomPicker" position="bottom" round>
                <van-picker
                        :columns="relateCustomList"
                        show-toolbar
                        value-key="name"
                        @cancel="showRelateCustomPicker = false"
                        @confirm="onRelateCustomConfirm"/>
            </van-popup>
            <van-popup v-model="showRadioInvoiceTypePicker" position="bottom" round>
                <van-picker
                        :columns="invoiceTypeColumns"
                        show-toolbar
                        @cancel="showRadioInvoiceTypePicker = false"
                        @confirm="onRadioPickerConfirm"/>
            </van-popup>
            <van-popup v-model="showRadioInvoiceMethodPicker" position="bottom" round>
                <van-picker
                        :columns="invoiceMethodColumns"
                        show-toolbar
                        @cancel="showRadioInvoiceMethodPicker = false"
                        @confirm="onRadioPickerConfirm"/>
            </van-popup>
            <van-popup v-model="showRadioInvoiceTitlePicker" position="bottom" round>
                <van-picker
                        :columns="invoiceTitleColumns"
                        show-toolbar
                        @cancel="showRadioInvoiceTitlePicker = false"
                        @confirm="onRadioPickerConfirm"/>
            </van-popup>
            <RelateOrderSelect v-if="selectOrderDialog"
                               :dialog-visible.sync="selectOrderDialog"
                               :projectId="projectId"
                               @success="handleClickOrderRow"/>
        </div>
    </van-popup>
</template>
<script>
import {uploadImg} from "@/utils/uploadOss";
import {formatFileSize} from "@/utils";
import {
    getFormFields,
    invoiceCreateOrder,
    InvoiceDetail,
    invoiceInfoByOrder,
} from "@/api";
import {pagination} from "@/mixins";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import RelateOrderSelect from "@/views/mobile/Order/component/relate_order_selet_popup.vue";

export default {
    name: "InvoiceDialog",
    data() {
        return {
            invoiceForm: {
                order_num: "", //订单编号
                invoice_company_name: "", //开票公司名称
                apply_time: "", //申请开票日期
                invoice_title_type: '', //发票抬头类型 1=个人 2=单位 , 订单里叫【开票对象】
                invoice_type: '', //发票类型 1:电子专票, 2:电子普票, 3:纸质专票, 4:纸质普票
                invoice_amount: "", //申请开票金额
                invoice_info: "", //开票信息     长文本
                apply_remark: "", // 申请备注
                apply_attachments: [], // 申请附件，JSON格式
                invoice_method: '', //发票提供方式: 1邮箱 2二维码 3其他 (根据实际情况定义)
                invoice_email: "", //  邮箱
                invoice_object: "", // 开票对象 未使用传空
                receive_name: '',
                receive_phone: '',
                receive_addr: ''
            },
            invoiceFormRules: {
                invoice_company_name: [{required: true, message: '请选择开票公司', trigger: 'onChange'}],
                invoice_type: [{required: true, message: '请选择发票类型', trigger: 'onChange'}],
                invoice_method: [{required: true, message: '请选择发票提供方式', trigger: 'onChange'}],
                invoice_email: [
                    {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "onBlur",
                    },
                    {
                        // 自定义校验规则
                        validator: (value) => {
                            return /.+@.+\..+/.test(value);
                        },
                        message: "请输入正确的邮箱",
                        trigger: "onBlur",
                    }
                ],
                invoice_amount: [{required: true, message: '请输入本次开票金额', trigger: 'onBlur'}],
                invoice_info: [{required: true, message: '请输入开票信息', trigger: 'onBlur'}],
                receive_name: [{required: true, message: '请输入收货人', trigger: 'onBlur'}],
                receive_phone: [{required: true, message: '请输入收货人电话', trigger: 'onBlur'}],
                receive_addr: [{required: true, message: '请输入收货地址', trigger: 'onBlur'}],
                invoice_title_type: [{required: true, message: '请选择开票对象', trigger: 'onChange'}],
            },
            orderDetailsData: {
                contact_name: '',
                can_receivable_amount: '',
                can_invoice_amount: '',
            },
            loading: false,
            selectOrderDialog: false,
            relateCustomList: [],
            invoice_info_auto: true,
            previewImgSrc: '',
            previewImgList: [],
            showRelateCustomPicker: false,
            showRadioInvoiceTypePicker: false,
            invoiceTypeColumns: [
                {text: '电子专票', value: 1},
                {text: '电子普票', value: 2},
                {text: '纸质专票', value: 3},
                {text: '纸质普票', value: 4},
            ],
            showRadioInvoiceMethodPicker: false,
            invoiceMethodColumns: [
                {text: '邮箱', value: 1},
                {text: '二维码', value: 2},
            ],
            showRadioInvoiceTitlePicker: false,
            invoiceTitleColumns: [
                {text: '个人', value: 1},
                {text: '单位', value: 2},
            ],
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: [Number, String],
            default: 0,
        },
        source: {
            type: String,
            default: 'list'
        },
        invoice_no: {
            type: String,
            default: ''
        },
        projectId: {
            type: Number,
            default: 0,
        },
    },
    mixins: [pagination],
    components: {RelateOrderSelect, ReturnNavBar},
    created() {
        if (this.order_id && this.source === 'detail') {
            this.invoiceForm.order_num = this.order_id
            this.getOrderDetail(this.order_id)
        }
        if (this.invoice_no) {
            this.getInvoiceDetail()
        }
    },
    mounted() {
    },
    methods: {
        //获取订单详情
        getOrderDetail(order_num) {
            this.loading = true
            invoiceInfoByOrder({
                order_num
            }).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData = res.data
                    this.relateCustomList = res.data.customer_list
                    this.invoiceForm.receive_addr = this.invoiceForm.receive_addr ? this.invoiceForm.receive_addr : res.data.receive_addr
                    this.invoiceForm.receive_phone = this.invoiceForm.receive_phone ? this.invoiceForm.receive_phone : res.data.receive_phone
                    this.invoiceForm.receive_name = this.invoiceForm.receive_name ? this.invoiceForm.receive_name : res.data.receive_name
                    getFormFields({
                        field_form: "customers"
                    }).then(res => {
                        if (res.code === 200) {
                            const invoice_note_field = res.data.find(item => item.field_key === 'invoice_note')
                            this.invoice_info_auto = !invoice_note_field.extend.initial_display
                            if (this.relateCustomList.length) {
                                const company = this.relateCustomList[0]
                                this.invoiceForm.invoice_company_name = company.name
                                if (this.invoice_info_auto) {
                                    this.invoiceForm.invoice_info = company.invoice_note
                                }
                                this.$set(this.orderDetailsData, 'contact_name', company.customer_contacts && company.customer_contacts.length ? company.customer_contacts[0].name : '')
                            }
                        }
                        this.loading = false
                    })
                } else {
                    this.$message.error(res.message)
                    this.loading = false
                }
            })
        },

        // 详情
        getInvoiceDetail() {
            this.loading = true;
            InvoiceDetail({invoice_no: this.invoice_no}).then((res) => {
                if (res.code === 200) {
                    this.invoiceForm.order_num = res.data.order_info.order_no
                    this.invoiceForm.invoice_company_name = res.data.invoice_info.invoice_company_name
                    this.invoiceForm.invoice_type = res.data.invoice_info.invoice_type
                    this.invoiceForm.invoice_method = res.data.invoice_info.invoice_method
                    this.invoiceForm.invoice_email = res.data.invoice_info.invoice_email
                    this.invoiceForm.invoice_amount = res.data.invoice_info.invoice_amount
                    this.invoiceForm.apply_remark = res.data.invoice_info.remark
                    this.invoiceForm.apply_attachments = res.data.invoice_info.attachments
                    this.invoiceForm.invoice_title_type = res.data.invoice_info.invoice_title_type
                    this.invoiceForm.receive_addr = res.data.invoice_info.receive_addr
                    this.invoiceForm.receive_name = res.data.invoice_info.receive_name
                    this.invoiceForm.receive_phone = res.data.invoice_info.receive_phone
                    this.invoiceForm.invoice_info = res.data.invoice_info.invoice_info
                    this.getOrderDetail(this.order_id)
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },

        //本次回款金额输入框失焦事件
        handleInvoiceAmountInputBlur() {
            let val = this.invoiceForm.invoice_amount.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            if (amount === 0) {
                this.$message.error('本次开票金额不能为0')
                this.invoiceForm.invoice_amount = ''
            } else if (amount > Number(this.orderDetailsData.can_invoice_amount)) {
                this.$message.error('本次开票金额不能大于可开票金额')
                this.invoiceForm.invoice_amount = Number(this.orderDetailsData.can_invoice_amount).toFixed(2)
            } else {
                this.invoiceForm.invoice_amount = amount.toFixed(2);
            }
        },

        //选择确认事件
        onRadioPickerConfirm(data) {
            if (this.showRadioInvoiceTypePicker) {
                this.showRadioInvoiceTypePicker = false
                this.invoiceForm.invoice_type = data.value
                this.handleInvoiceTypeChange(data.value)
            } else if (this.showRadioInvoiceMethodPicker) {
                this.showRadioInvoiceMethodPicker = false
                this.invoiceForm.invoice_method = data.value
            } else if (this.showRadioInvoiceTitlePicker) {
                this.showRadioInvoiceTitlePicker = false
                this.invoiceForm.invoice_title_type = data.value
            }
        },

        //发票类型切换事件
        handleInvoiceTypeChange(val) {
            if (val === 3 || val === 4) {
                this.invoiceForm.receive_name = this.orderDetailsData.receive_name
                this.invoiceForm.receive_phone = this.orderDetailsData.receive_phone
                this.invoiceForm.receive_addr = this.orderDetailsData.receive_addr
            } else {
                this.invoiceForm.receive_name = ''
                this.invoiceForm.receive_phone = ''
                this.invoiceForm.receive_addr = ''
            }
            this.invoiceForm.invoice_method = ''
            this.invoiceForm.invoice_email = ''
        },

        //上传文件
        handleUploadFileChange(e) {
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$message.error('附件大小不能超过50m')
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.invoiceForm.apply_attachments.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不允许预览，请下载后查看')
                }
            }
        },

        //点击选择订单
        handleClickOrderRow(row) {
            this.invoiceForm.order_num = row.order_num
            this.getOrderDetail(row.order_num)
        },

        //点击切换关联客户
        onRelateCustomConfirm(item) {
            this.invoiceForm.invoice_company_name = item.name
            if (this.invoice_info_auto) {
                this.invoiceForm.invoice_info = item.invoice_note
            }
            if (item.customer_contacts.length) {
                this.$set(this.orderDetailsData, 'contact_name', item.customer_contacts[0].name)
            }
            this.showRelateCustomPicker = false
        },

        //点击查看商机详情
        handleClickBusinessDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: row.project_id,
                    name: row.project_name,
                },
            });
        },

        //点击查看关联客户详情
        handleClickCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.customer_name,
                },
            });
        },

        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id,
                    name: row.order_num,
                },
            });
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:invoice_no', '')
        },

        //确定事件
        handleClickConfirm() {
            this.$refs.invoiceForm.validate().then(() => {
                invoiceCreateOrder(this.invoiceForm).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('开票申请提交成功')
                        this.$emit('update:dialogVisible', false)
                        this.$emit('refresh')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(error => {
                if (error.length) {
                    this.$toast.fail(error[0].message)
                }
            })
        },
    },
}
</script>
<style lang="scss">

</style>